module.exports = __webpack_public_path__ + "media/images/top/shop-list-aeon-4a1109b8b83e9afe50a6998304f79d34.webp";